import React from "react";
import { createRoot } from "react-dom/client";
import { useFieldArray, useForm } from "react-hook-form";
import {
  AlertFillIcon,
  CheckCircleIcon,
  IssueDraftIcon,
} from "@primer/octicons-react";

const h = React.createElement;

const priorityOptions = [
  { label: "high priority", value: "high" },
  { label: "moderate", value: "moderate" },
  { label: "low priority", value: "low" },
  { label: "not applicable", value: "n/a" },
];

const professionalClientRequiredGroups = [
  ["professional_client.understanding", "professional_client.work"],
  [
    "professional_client.generally",
    "professional_client.shares",
    "professional_client.unit",
  ],
];

const countryOptions = [
  { label: "Afghanistan", value: "AFG" },
  { label: "Åland Islands", value: "ALA" },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  { label: "American Samoa", value: "ASM" },
  { label: "Andorra", value: "AND" },
  { label: "Angola", value: "AGO" },
  { label: "Anguilla", value: "AIA" },
  { label: "Antarctica", value: "ATA" },
  { label: "Antigua and Barbuda", value: "ATG" },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  { label: "Aruba", value: "ABW" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUT" },
  { label: "Azerbaijan", value: "AZE" },
  { label: "Bahamas", value: "BHS" },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  { label: "Barbados", value: "BRB" },
  { label: "Belarus", value: "BLR" },
  { label: "Belgium", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  { label: "Benin", value: "BEN" },
  { label: "Bermuda", value: "BMU" },
  { label: "Bhutan", value: "BTN" },
  { label: "Bolivia, Plurinational State of", value: "BOL" },
  { label: "Bonaire, Sint Eustatius and Saba", value: "BES" },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  { label: "Bouvet Island", value: "BVT" },
  { label: "Brazil", value: "BRA" },
  { label: "British Indian Ocean Territory", value: "IOT" },
  { label: "Brunei Darussalam", value: "BRN" },
  { label: "Bulgaria", value: "BGR" },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  { label: "Cabo Verde", value: "CPV" },
  { label: "Cambodia", value: "KHM" },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  { label: "Cayman Islands", value: "CYM" },
  { label: "Central African Republic", value: "CAF" },
  { label: "Chad", value: "TCD" },
  { label: "Chile", value: "CHL" },
  { label: "China", value: "CHN" },
  { label: "Christmas Island", value: "CXR" },
  { label: "Cocos (Keeling) Islands", value: "CCK" },
  { label: "Colombia", value: "COL" },
  { label: "Comoros", value: "COM" },
  { label: "Congo", value: "COG" },
  { label: "Congo, Democratic Republic of the", value: "COD" },
  { label: "Cook Islands", value: "COK" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Croatia", value: "HRV" },
  { label: "Cuba", value: "CUB" },
  { label: "Curaçao", value: "CUW" },
  { label: "Cyprus", value: "CYP" },
  { label: "Czechia", value: "CZE" },
  { label: "Côte d'Ivoire", value: "CIV" },
  { label: "Denmark", value: "DNK" },
  { label: "Djibouti", value: "DJI" },
  { label: "Dominica", value: "DMA" },
  { label: "Dominican Republic", value: "DOM" },
  { label: "Ecuador", value: "ECU" },
  { label: "Egypt", value: "EGY" },
  { label: "El Salvador", value: "SLV" },
  { label: "Equatorial Guinea", value: "GNQ" },
  { label: "Eritrea", value: "ERI" },
  { label: "Estonia", value: "EST" },
  { label: "Eswatini", value: "SWZ" },
  { label: "Ethiopia", value: "ETH" },
  { label: "Falkland Islands (Malvinas)", value: "FLK" },
  { label: "Faroe Islands", value: "FRO" },
  { label: "Fiji", value: "FJI" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRA" },
  { label: "French Guiana", value: "GUF" },
  { label: "French Polynesia", value: "PYF" },
  { label: "French Southern Territories", value: "ATF" },
  { label: "Gabon", value: "GAB" },
  { label: "Gambia", value: "GMB" },
  { label: "Georgia", value: "GEO" },
  { label: "Germany", value: "DEU" },
  { label: "Ghana", value: "GHA" },
  { label: "Gibraltar", value: "GIB" },
  { label: "Greece", value: "GRC" },
  { label: "Greenland", value: "GRL" },
  { label: "Grenada", value: "GRD" },
  { label: "Guadeloupe", value: "GLP" },
  { label: "Guam", value: "GUM" },
  { label: "Guatemala", value: "GTM" },
  { label: "Guernsey", value: "GGY" },
  { label: "Guinea", value: "GIN" },
  { label: "Guinea-Bissau", value: "GNB" },
  { label: "Guyana", value: "GUY" },
  { label: "Haiti", value: "HTI" },
  { label: "Heard Island and McDonald Islands", value: "HMD" },
  { label: "Holy See", value: "VAT" },
  { label: "Honduras", value: "HND" },
  { label: "Hong Kong", value: "HKG" },
  { label: "Hungary", value: "HUN" },
  { label: "Iceland", value: "ISL" },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  { label: "Iran, Islamic Republic of", value: "IRN" },
  { label: "Iraq", value: "IRQ" },
  { label: "Ireland", value: "IRL" },
  { label: "Isle of Man", value: "IMN" },
  { label: "Israel", value: "ISR" },
  { label: "Italy", value: "ITA" },
  { label: "Jamaica", value: "JAM" },
  { label: "Japan", value: "JPN" },
  { label: "Jersey", value: "JEY" },
  { label: "Jordan", value: "JOR" },
  { label: "Kazakhstan", value: "KAZ" },
  { label: "Kenya", value: "KEN" },
  { label: "Kiribati", value: "KIR" },
  { label: "Korea, Democratic People's Republic of", value: "PRK" },
  { label: "Korea, Republic of", value: "KOR" },
  { label: "Kuwait", value: "KWT" },
  { label: "Kyrgyzstan", value: "KGZ" },
  { label: "Lao People's Democratic Republic", value: "LAO" },
  { label: "Latvia", value: "LVA" },
  { label: "Lebanon", value: "LBN" },
  { label: "Lesotho", value: "LSO" },
  { label: "Liberia", value: "LBR" },
  { label: "Libya", value: "LBY" },
  { label: "Liechtenstein", value: "LIE" },
  { label: "Lithuania", value: "LTU" },
  { label: "Luxembourg", value: "LUX" },
  { label: "Macao", value: "MAC" },
  { label: "Madagascar", value: "MDG" },
  { label: "Malawi", value: "MWI" },
  { label: "Malaysia", value: "MYS" },
  { label: "Maldives", value: "MDV" },
  { label: "Mali", value: "MLI" },
  { label: "Malta", value: "MLT" },
  { label: "Marshall Islands", value: "MHL" },
  { label: "Martinique", value: "MTQ" },
  { label: "Mauritania", value: "MRT" },
  { label: "Mauritius", value: "MUS" },
  { label: "Mayotte", value: "MYT" },
  { label: "Mexico", value: "MEX" },
  { label: "Micronesia, Federated States of", value: "FSM" },
  { label: "Moldova, Republic of", value: "MDA" },
  { label: "Monaco", value: "MCO" },
  { label: "Mongolia", value: "MNG" },
  { label: "Montenegro", value: "MNE" },
  { label: "Montserrat", value: "MSR" },
  { label: "Morocco", value: "MAR" },
  { label: "Mozambique", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibia", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  { label: "Nepal", value: "NPL" },
  { label: "Netherlands, Kingdom of the", value: "NLD" },
  { label: "New Caledonia", value: "NCL" },
  { label: "New Zealand", value: "NZL" },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niger", value: "NER" },
  { label: "Nigeria", value: "NGA" },
  { label: "Niue", value: "NIU" },
  { label: "Norfolk Island", value: "NFK" },
  { label: "North Macedonia", value: "MKD" },
  { label: "Northern Mariana Islands", value: "MNP" },
  { label: "Norway", value: "NOR" },
  { label: "Oman", value: "OMN" },
  { label: "Pakistan", value: "PAK" },
  { label: "Palau", value: "PLW" },
  { label: "Palestine, State of", value: "PSE" },
  { label: "Panama", value: "PAN" },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Philippines", value: "PHL" },
  { label: "Pitcairn", value: "PCN" },
  { label: "Poland", value: "POL" },
  { label: "Portugal", value: "PRT" },
  { label: "Puerto Rico", value: "PRI" },
  { label: "Qatar", value: "QAT" },
  { label: "Romania", value: "ROU" },
  { label: "Russian Federation", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Réunion", value: "REU" },
  { label: "Saint Barthélemy", value: "BLM" },
  { label: "Saint Helena, Ascension and Tristan da Cunha", value: "SHN" },
  { label: "Saint Kitts and Nevis", value: "KNA" },
  { label: "Saint Lucia", value: "LCA" },
  { label: "Saint Martin (French part)", value: "MAF" },
  { label: "Saint Pierre and Miquelon", value: "SPM" },
  { label: "Saint Vincent and the Grenadines", value: "VCT" },
  { label: "Samoa", value: "WSM" },
  { label: "San Marino", value: "SMR" },
  { label: "Sao Tome and Principe", value: "STP" },
  { label: "Saudi Arabia", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Serbia", value: "SRB" },
  { label: "Seychelles", value: "SYC" },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapore", value: "SGP" },
  { label: "Sint Maarten (Dutch part)", value: "SXM" },
  { label: "Slovakia", value: "SVK" },
  { label: "Slovenia", value: "SVN" },
  { label: "Solomon Islands", value: "SLB" },
  { label: "Somalia", value: "SOM" },
  { label: "South Africa", value: "ZAF" },
  { label: "South Georgia and the South Sandwich Islands", value: "SGS" },
  { label: "South Sudan", value: "SSD" },
  { label: "Spain", value: "ESP" },
  { label: "Sri Lanka", value: "LKA" },
  { label: "Sudan", value: "SDN" },
  { label: "Suriname", value: "SUR" },
  { label: "Svalbard and Jan Mayen", value: "SJM" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  { label: "Syrian Arab Republic", value: "SYR" },
  { label: "Taiwan, Province of China", value: "TWN" },
  { label: "Tajikistan", value: "TJK" },
  { label: "Tanzania, United Republic of", value: "TZA" },
  { label: "Thailand", value: "THA" },
  { label: "Timor-Leste", value: "TLS" },
  { label: "Togo", value: "TGO" },
  { label: "Tokelau", value: "TKL" },
  { label: "Tonga", value: "TON" },
  { label: "Trinidad and Tobago", value: "TTO" },
  { label: "Tunisia", value: "TUN" },
  { label: "Turkmenistan", value: "TKM" },
  { label: "Turks and Caicos Islands", value: "TCA" },
  { label: "Tuvalu", value: "TUV" },
  { label: "Türkiye", value: "TUR" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "ARE" },
  {
    label: "United Kingdom of Great Britain and Northern Ireland",
    value: "GBR",
  },
  { label: "United States Minor Outlying Islands", value: "UMI" },
  { label: "United States of America", value: "USA" },
  { label: "Uruguay", value: "URY" },
  { label: "Uzbekistan", value: "UZB" },
  { label: "Vanuatu", value: "VUT" },
  { label: "Venezuela, Bolivarian Republic of", value: "VEN" },
  { label: "Viet Nam", value: "VNM" },
  { label: "Virgin Islands (British)", value: "VGB" },
  { label: "Virgin Islands (U.S.)", value: "VIR" },
  { label: "Wallis and Futuna", value: "WLF" },
  { label: "Western Sahara", value: "ESH" },
  { label: "Yemen", value: "YEM" },
  { label: "Zambia", value: "ZMB" },
  { label: "Zimbabwe", value: "ZWE" },
];

const stages = [
  {
    title: "General Information",
    names: [
      "general.tax_residency",
      "general.tax_number",
      "general.mailing_address",
      "general.phone_number",
      "general.purpose",
      "general.income_sources",
      "general.investment",
      "general.sow",
      "general.pep",
    ],
    fields: [
      {
        label: "Tax residency",
        name: "general.tax_residency",
        type: "select",
        options: countryOptions,
        required: true,
      },
      {
        label: "Tax number",
        name: "general.tax_number",
        type: "string",
        required: true,
      },
      {
        label: "Mailing address (if different from the address of residence)",
        name: "general.mailing_address",
        type: "textarea",
        paragraph:
          "State / jurisdiction, postal code, town, street / district, house number and if available apartment number",
      },
      {
        label: "Contact phone number",
        name: "general.phone_number",
        type: "phone",
      },
      {
        label: "Purpose and type of your business relationship with the Fund",
        name: "general.purpose",
        type: "textarea",
        paragraph:
          "Investment, long-term savings, income generation, hedging, etc.",
        required: true,
      },
      {
        label: "Sources of income",
        name: "general.income_sources",
        type: "textarea",
        paragraph: "Salary, dividends, income from business activities, etc.",
        required: true,
      },
      {
        label: "Planned initial investment (equivalent in USD)",
        name: "general.investment",
        type: "number",
        required: true,
        min: 100000,
      },
      {
        label: "Documents to verify your income and wealth",
        name: "general.sow",
        type: "documents",
        paragraph:
          "Bank statements, statements from financial institutions detailing holdings, documents showing ownership or equity stakes in businesses",
        required: true,
      },
      {
        label:
          "Are you or any immediate family member a politically exposed person (PEP)?",
        name: "general.pep",
        type: "radiobutton",
        paragraph:
          "PEP is a natural person (including a family member or known associate) who is or has been entrusted with a prominent public function, including but not limited to: a head of state or of government, senior politician, member of a legislative or constitutional assembly, senior government official, senior judicial official, senior military officer, ambassador, senior person in an international organisation, senior executive of a state-owned entity, a senior political party official, or an individual who has been entrusted with similar functions such as a director or a deputy director; at an international, national, or regional level.",
        required: true,
        options: [
          { label: "An official public person", value: "official" },
          { label: "Spouse and close relatives", value: "spouse-or-relative" },
          { label: "No", value: "no" },
        ],
      },
    ],
  },
  {
    title: "Employment and Business Experience",
    names: [
      "employment.occupation",
      "employment.salary",
      "employment.own_business_or_employed",
      "employment.business_or_employer",
      "employment.responsibilities",
      "employment.length_employer",
      "employment.position",
      "employment.length_position",
      "employment.cv",
    ],
    fields: [
      {
        label: "Present occupation",
        name: "employment.occupation",
        type: "string",
      },
      { label: "Salary", name: "employment.salary", type: "string" },
      {
        label: "Do you own your own business or are you otherwise employed?",
        name: "employment.own_business_or_employed",
        type: "textarea",
      },
      {
        label: "Name and type of business employed by or owned",
        name: "employment.business_or_employer",
        type: "textarea",
      },
      {
        label: "Description of responsibilities",
        name: "employment.responsibilities",
        type: "textarea",
      },
      {
        label:
          "Length of service with present employer or length of ownership of present business",
        name: "employment.length_employer",
        type: "string",
      },
      {
        label: "Present title or position",
        name: "employment.position",
        type: "string",
      },
      {
        label: "Length of service in present title or position",
        name: "employment.length_position",
        type: "string",
      },
      {
        label: "CV or other employment record",
        name: "employment.cv",
        type: "documents",
      },
    ],
  },
  {
    title: "Prior Occupations",
    names: ["prior_occupations.occupations"],
    paragraph: "Employment and length of service during the past five years",
    fields: [
      {
        name: "prior_occupations.occupations",
        type: "array",
        addLabel: "Add occupation",
        defaultValue: { occupation: "", name: "", type: "", years: "" },
        fields: [
          {
            label: "Occupation",
            name: "occupation",
            type: "string",
            required: true,
          },
          {
            label: "Name of employer or owned business",
            name: "name",
            type: "string",
            required: true,
          },
          {
            label: "Type",
            name: "type",
            type: "radiobutton",
            required: true,
            options: [
              { label: "Employer", value: "employer" },
              { label: "Owned Business", value: "business" },
            ],
          },
          {
            label: "Years of service",
            name: "years",
            type: "string",
            required: true,
          },
        ],
      },
    ],
  },
  {
    title: "Licenses",
    names: ["licenses.licenses"],
    paragraph:
      "Please list if you have any professional licenses, registrations, certifications or designations, including bar admissions, accounting certificates, valuation certificates, practising certificates, investment adviser registrations, and qualifications in the AIFC or any jurisdiction or approved person status by the AFSA or other financial services regulator in any jurisdiction.",
    fields: [
      {
        name: "licenses.licenses",
        type: "array",
        addLabel: "Add license",
        defaultValue: { name: "", expiry_date: "", documents: [] },
        fields: [
          {
            label: "License",
            name: "name",
            type: "string",
            required: true,
          },
          {
            label: "Expiry date",
            name: "expiry_date",
            type: "date",
            required: true,
          },
          {
            label: "Document",
            name: "documents",
            type: "documents",
            required: true,
          },
        ],
      },
    ],
  },
  {
    title: "Education (College and Postgraduate)",
    names: ["education.diploma", "education.degrees"],
    fields: [
      {
        label:
          "Diploma in the fields of finance, economics, accounting, high math, and IT, or certificates (translated to English and notarized)",
        name: "education.diploma",
        type: "documents",
      },
      {
        name: "education.degrees",
        type: "array",
        addLabel: "Add degree",
        defaultValue: { institution: "", degree: "", date: "" },
        fields: [
          {
            label: "Institution",
            name: "institution",
            type: "string",
            required: true,
          },
          { label: "Degree", name: "degree", type: "string", required: true },
          {
            label: "Date of completion",
            name: "date",
            type: "date",
            required: true,
          },
        ],
      },
    ],
  },
  {
    title: "Current Investment Objectives",
    names: [
      "investment_objectives.income",
      "investment_objectives.appreciation",
      "investment_objectives.tax_shelter",
      "investment_objectives.other",
    ],
    fields: [
      {
        label: "Current income",
        name: "investment_objectives.income",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Appreciation",
        name: "investment_objectives.appreciation",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Tax Shelter",
        name: "investment_objectives.tax_shelter",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Other",
        name: "investment_objectives.other",
        type: "textarea",
      },
    ],
  },
  {
    title: "Other Relevant Information",
    names: ["other_relevant.other"],
    fields: [
      {
        label:
          "Please describe any additional information that reflects your knowledge and experience in business, financial, or investment matters and your ability to evaluate the merits and risks of this investment:",
        name: "other_relevant.other",
        type: "textarea",
      },
    ],
  },
  {
    title: "Assessed Professional Client",
    names: [
      "professional_client.net",
      "professional_client.understanding",
      "professional_client.work",
      "professional_client.generally",
      "professional_client.shares",
      "professional_client.unit",
      "professional_client.trading_history",
    ],
    paragraph:
      "I am an Assessed Professional Client (as defined in Rule 2.5.1 of the AIFC COB enacted under the AIFC Financial Services Framework Regulations No. 18 of 2017) because (check all appropriate descriptions that apply):",
    fields: [
      {
        label:
          "I am a Client who has net assets of at least USD 100,000 (for this purposes, the calculation of my net assets, the value of my primary residence is excluded and includes any assets held directly or indirectly by me);",
        name: "professional_client.net",
        type: "checkbox",
        required: true,
      },
      {
        label:
          "I have a sufficient experience and understanding of the participating shares in investment companies with variable share capital, subscription agreements, and all related financial products, financial services, transactions and any associated risks;",
        name: "professional_client.understanding",
        type: "checkbox",
      },
      {
        label:
          "I work or have worked in the previous two years in an Authorised Firm or any other authorised or regulated financial institution, including a bank, securities firm or insurance company, in a position that requires knowledge of the type of financial produces, financial services or transactions envisaged.",
        name: "professional_client.work",
        type: "checkbox",
      },
      {
        type: "paragraph",
        text: "I wish to be treated as a Professional Client either (check all appropriate descriptions that apply):",
      },
      {
        label: "generally;",
        name: "professional_client.generally",
        type: "checkbox",
      },
      {
        label:
          "in respect of the Participating Shares in and commitment to the Fund, the management of the Fund and its assets, and the entry into and performance and variation of the Subscription Agreement, subscribing to any additional Participating Shares, making any Additional Investment Amounts, receiving distributions (if any) or redeeming Participating Shares, and transferring the Participating Shares or being prohibited from making such transfer;",
        name: "professional_client.shares",
        type: "checkbox",
      },
      {
        label:
          "in respect of a unit in and commitment to an entity which is a collective investment scheme, the management of an entity, which is a collective investment scheme and its assets, and the entry into and performance and variation of a subscription agreement, subscribing to any additional units or increasing a commitment and making additional contributions to an entity, receiving distributions or making redemptions of and transferring a unit or being prohibited from making such transfer.",
        name: "professional_client.unit",
        type: "checkbox",
      },
      {
        label: "Trading history (within the last 24 months)",
        name: "professional_client.trading_history",
        type: "documents",
      },
    ],
  },
  {
    title: "Manner of Solicitation",
    names: ["solicitation.manner", "solicitation.name", "solicitation.date"],
    fields: [
      {
        label:
          "Please state the manner in which you became aware of the investment (for example, by personal contact or acquaintance with an investment advisor or counselor, with Fund Manager personnel, a broker-dealer, or otherwise):",
        name: "solicitation.manner",
        type: "string",
        required: true,
      },
      {
        label: "Name of the contact person",
        name: "solicitation.name",
        type: "string",
        required: true,
      },
      {
        label: "Date",
        name: "solicitation.date",
        type: "date",
        required: true,
      },
    ],
  },
];

function defaultValues() {
  return stages.reduce((values, stage) => {
    stage.fields.forEach((field) => {
      if (!field.name) return;

      if (field.type === "array" || field.type === "documents") {
        setPath(values, field.name, []);
      } else if (field.type === "checkbox") setPath(values, field.name, false);
      else setPath(values, field.name, "");
    });

    return values;
  }, {});
}

function csrfToken() {
  return document
    .querySelector("meta[name='csrf-token']")
    ?.getAttribute("content");
}

function stageBody(values, names) {
  return names.reduce((body, name) => {
    setPath(body, name, getPath(values, name));
    return body;
  }, {});
}

function getPath(object, path) {
  return path.split(".").reduce((value, key) => value?.[key], object);
}

function hasPath(object, path) {
  let value = object;

  return path.split(".").every((key) => {
    if (!value || !Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }

    value = value[key];
    return true;
  });
}

function setPath(object, path, value) {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const target = keys.reduce((memo, key) => {
    memo[key] ||= {};
    return memo[key];
  }, object);

  target[lastKey] = value;
}

function deepMerge(...objects) {
  return objects.reduce((result, object) => {
    Object.entries(object || {}).forEach(([key, value]) => {
      if (isPlainObject(value) && isPlainObject(result[key])) {
        result[key] = deepMerge(result[key], value);
      } else {
        result[key] = value;
      }
    });

    return result;
  }, {});
}

function isPlainObject(value) {
  return value && typeof value === "object" && !Array.isArray(value);
}

function samePayload(left, right) {
  return JSON.stringify(left) === JSON.stringify(right);
}

function stageIsComplete(stage, values, serverPayload) {
  return (
    stage.names.every((name) => hasPath(serverPayload, name)) &&
    stageIsValid(stage, values) &&
    samePayload(
      stageBody(values, stage.names),
      stageBody(serverPayload, stage.names),
    )
  );
}

function stageIsValid(stage, values) {
  return (
    stage.fields.every((field) =>
      field.type === "paragraph"
        ? true
        : fieldIsValid(field, getPath(values, field.name)),
    ) && professionalClientGroupsAreValid(stage, values)
  );
}

function professionalClientGroupsAreValid(stage, values) {
  return professionalClientRequiredGroups.every(
    (group) =>
      !stageIncludesAllNames(stage, group) ||
      group.some((fieldName) => getPath(values, fieldName) === true),
  );
}

function stageIncludesAllNames(stage, names) {
  return names.every((fieldName) => stage.names.includes(fieldName));
}

function responseErrorMessage(status) {
  if (status === 500) return "Something went wrong";
  if (status === 422)
    return "Form submission failed—please reload the page and try again";

  return `Request failed with ${status}`;
}

function fieldIsValid(field, value) {
  if (field.type === "paragraph") return true;

  if (field.type === "array") {
    return (value || []).every((item) =>
      field.fields.every((subfield) =>
        fieldIsValid(subfield, getPath(item, subfield.name)),
      ),
    );
  }

  if (field.type === "documents") return !field.required || value?.length > 0;

  if (!field.required) return true;

  if (field.type === "checkbox") return value === true;

  if (field.type === "number") {
    return (
      Number.isInteger(value) &&
      (field.min === undefined || value >= field.min)
    );
  }

  return value !== undefined && value !== null && String(value).trim() !== "";
}

function Field({ field, register, errors, onChange }) {
  if (field.type === "paragraph") {
    return h("p", { style: styles.paragraph }, field.text);
  }

  const error = getPath(errors, field.name);

  if (field.type === "array") return null;

  if (field.type === "checkbox") {
    return h(
      "div",
      { style: styles.field },
      h(
        "label",
        { style: styles.checkboxOption },
        renderInput(field, register, "", onChange),
        h("span", null, field.label),
      ),
      field.paragraph && h("small", { style: styles.help }, field.paragraph),
      errorMessage(error),
    );
  }

  return h(
    "label",
    { style: styles.field },
    h("span", { style: styles.label }, field.label),
    field.paragraph && h("small", { style: styles.help }, field.paragraph),
    renderInput(field, register, "", onChange),
    errorMessage(error),
  );
}

function renderInput(field, register, namePrefix = "", onChange) {
  const name = `${namePrefix}${field.name}`;
  const options = registrationOptions(field);
  const registration = register(name, options);
  const handleChange = (event) => {
    if (field.type === "number") {
      event.currentTarget.value = formatNumberInputValue(
        event.currentTarget.value,
      );
    }

    registration.onChange(event);
    onChange?.(name);
  };

  if (field.type === "textarea") {
    return h("textarea", {
      ...registration,
      onInput: autosizeTextarea,
      onChange: (event) => {
        handleChange(event);
        autosizeTextarea(event);
      },
      rows: 1,
      style: styles.textarea,
    });
  }

  if (field.type === "select") {
    return h(
      "select",
      {
        ...registration,
        onChange: handleChange,
        style: styles.input,
      },
      h("option", { value: "" }, ""),
      field.options.map((option) =>
        h("option", { key: option.value, value: option.value }, option.label),
      ),
    );
  }

  if (field.type === "checkbox") {
    return h("input", {
      ...registration,
      onChange: handleChange,
      type: "checkbox",
      style: styles.choiceInput,
    });
  }

  if (field.type === "radiobutton") {
    return h(
      "div",
      { style: styles.radioGroup },
      field.options.map((option) =>
        h(
          "label",
          { key: option.value, style: styles.radioOption },
          h("input", {
            ...registration,
            onChange: handleChange,
            type: "radio",
            value: option.value,
            style: styles.choiceInput,
          }),
          h("span", null, option.label),
        ),
      ),
    );
  }

  return h("input", {
    ...registration,
    ref: (element) => {
      registration.ref(element);

      if (field.type === "number" && element) {
        element.value = formatNumberInputValue(element.value);
      }
    },
    onChange: handleChange,
    type:
      field.type === "date" ? "date" : field.type === "phone" ? "tel" : "text",
    inputMode: field.type === "number" ? "numeric" : undefined,
    min: field.type === "number" ? field.min : undefined,
    pattern: field.type === "number" ? "[0-9,]*" : undefined,
    style: styles.input,
  });
}

function numberInputDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function formatNumberInputValue(value) {
  return numberInputDigits(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function registrationOptions(field) {
  const options = field.required ? { required: "This field is required" } : {};

  if (["string", "phone", "textarea"].includes(field.type)) {
    options.validate = (value) =>
      !field.required ||
      String(value || "").trim() !== "" ||
      "This field is required";
  }

  if (field.type === "number") {
    options.setValueAs = (value) => {
      const digits = numberInputDigits(value);

      if (digits === "") return "";

      return Number(digits);
    };
    options.validate = (value) => {
      if (value === "") return !field.required || "This field is required";
      if (!Number.isInteger(value)) return "Enter a whole number";
      if (field.min !== undefined && value < field.min) {
        return `Minimum value is ${field.min}`;
      }

      return true;
    };
  }

  return options;
}

function trimStringPayload(value) {
  if (typeof value === "string") return value.trim();

  if (Array.isArray(value)) return value.map((item) => trimStringPayload(item));

  if (isPlainObject(value)) {
    return Object.entries(value).reduce(
      (payload, [key, item]) => ({
        ...payload,
        [key]: trimStringPayload(item),
      }),
      {},
    );
  }

  return value;
}

function documentFileName(document) {
  return (
    document.file_filename || document.name || document.filename || "Document"
  );
}

function autosizeTextarea(event) {
  const textarea = event.currentTarget;

  textarea.style.height = "auto";
  textarea.style.height = `${textarea.scrollHeight}px`;
}

function autosizeTextareas(root = document) {
  root.querySelectorAll("textarea").forEach((textarea) => {
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  });
}

function errorMessage(error, message = "This field is required") {
  return (
    error &&
    h(
      "small",
      { role: "alert", style: styles.error },
      h(AlertFillIcon, { size: 16, style: styles.errorIcon }),
      h("span", null, error.message || message),
    )
  );
}

function validateStageDocuments(stage, values, setError, clearErrors) {
  return stage.fields.reduce((valid, field) => {
    if (field.type !== "documents" || !field.required) return valid;

    const documents = getPath(values, field.name);
    if (Array.isArray(documents) && documents.length > 0) {
      clearErrors(field.name);
      return valid;
    }

    setError(field.name, {
      type: "required",
      message: "This field is required",
    });

    return false;
  }, true);
}

function validateProfessionalClientGroups(
  stage,
  values,
  setError,
  clearErrors,
) {
  return professionalClientRequiredGroups.reduce((valid, group) => {
    if (!stageIncludesAllNames(stage, group)) return valid;

    return validateProfessionalClientGroup(group, values, setError, clearErrors)
      ? valid
      : false;
  }, true);
}

function validateProfessionalClientGroup(group, values, setError, clearErrors) {
  if (group.some((fieldName) => getPath(values, fieldName) === true)) {
    clearErrors(group);
    return true;
  }

  group.forEach((fieldName) => {
    setError(fieldName, {
      type: "required",
      message: "At least one of these fields is required",
    });
  });

  return false;
}

function professionalClientGroupForField(stage, name) {
  return professionalClientRequiredGroups.find(
    (group) => group.includes(name) && stageIncludesAllNames(stage, group),
  );
}

function DocumentsField({
  clearErrors,
  documentUrl,
  errors,
  field,
  register,
  setError,
  setValue,
  values,
}) {
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState("");
  const documents = getPath(values, field.name) || [];
  const error = getPath(errors, field.name);

  React.useEffect(() => {
    register(field.name, {
      validate: (value) =>
        !field.required || value?.length > 0 || "This field is required",
    });
  }, [field.name, field.required, register]);

  const updateDocuments = (nextDocuments) => {
    setValue(field.name, nextDocuments, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    if (field.required && nextDocuments.length === 0) {
      setError(field.name, {
        type: "required",
        message: "This field is required",
      });
    } else {
      clearErrors(field.name);
    }
  };

  const uploadFiles = async (event) => {
    const files = Array.from(event.currentTarget.files || []);
    event.currentTarget.value = "";

    if (files.length === 0) return;

    setUploading(true);
    setUploadError("");

    try {
      const uploadedDocuments = [];

      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);

        const token = csrfToken();
        const response = await fetch(documentUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            ...(token ? { "X-CSRF-Token": token } : {}),
          },
          body: formData,
        });

        if (!response.ok)
          throw new Error(`Upload failed with ${response.status}`);

        uploadedDocuments.push(await response.json());
      }

      updateDocuments([...documents, ...uploadedDocuments]);
    } catch (error) {
      setUploadError(error instanceof Error ? error.message : "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return h(
    "div",
    { style: styles.field },
    h("span", { style: styles.label }, field.label),
    field.paragraph && h("small", { style: styles.help }, field.paragraph),
    documents.length > 0 &&
      h(
        "ul",
        { style: styles.documentsList },
        documents.map((document, index) =>
          h(
            "li",
            { key: document.id || `${documentFileName(document)}-${index}` },
            h("span", null, documentFileName(document)),
            h(
              "a",
              {
                style: styles.documentRemove,
                onClick: () =>
                  updateDocuments(documents.filter((_, i) => i !== index)),
              },
              "Remove",
            ),
          ),
        ),
      ),
    h("input", {
      accept: "application/pdf",
      disabled: uploading || !documentUrl,
      multiple: true,
      onChange: uploadFiles,
      type: "file",
    }),
    uploading && h("small", { style: styles.help }, "Uploading..."),
    errorMessage(!documentUrl, "Document upload URL is missing"),
    errorMessage(uploadError, uploadError),
    errorMessage(error),
  );
}

function ArrayField({
  clearErrors,
  documentUrl,
  field,
  control,
  errors,
  onChange,
  register,
  setError,
  setValue,
  values,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: field.name,
  });

  return h(
    "div",
    { style: styles.arrayField },
    fields.map((item, index) =>
      h(
        "section",
        { key: item.id, style: styles.arrayItem },
        h(
          "button",
          {
            type: "button",
            onClick: () => remove(index),
            className: "btn_secondary",
            "aria-label": "Remove item",
            style: styles.arrayRemoveButton,
          },
          "Remove",
        ),
        field.fields.map((subfield) => {
          const error = getPath(
            errors,
            `${field.name}.${index}.${subfield.name}`,
          );

          if (subfield.type === "documents") {
            return h(DocumentsField, {
              key: subfield.name,
              clearErrors,
              documentUrl,
              errors,
              field: {
                ...subfield,
                name: `${field.name}.${index}.${subfield.name}`,
              },
              register,
              setError,
              setValue,
              values,
            });
          }

          return subfield.type === "checkbox"
            ? h(
                "div",
                { key: subfield.name, style: styles.field },
                h(
                  "label",
                  { style: styles.checkboxOption },
                  renderInput(
                    subfield,
                    register,
                    `${field.name}.${index}.`,
                    onChange,
                  ),
                  h("span", null, subfield.label),
                ),
                errorMessage(error),
              )
            : h(
                "label",
                { key: subfield.name, style: styles.field },
                h("span", { style: styles.label }, subfield.label),
                renderInput(
                  subfield,
                  register,
                  `${field.name}.${index}.`,
                  onChange,
                ),
                errorMessage(error),
              );
        }),
      ),
    ),
    h(
      "button",
      {
        type: "button",
        onClick: () => append({ ...field.defaultValue }),
        className: "btn_secondary",
        style: styles.arrayAddButton,
      },
      field.addLabel,
    ),
  );
}

function KycForm({ documentUrl, url }) {
  const [stageIndex, setStageIndex] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [submitting, setSubmitting] = React.useState(false);
  const [initHtml, setInitHtml] = React.useState("");
  const [submitError, setSubmitError] = React.useState("");
  const [serverPayload, setServerPayload] = React.useState({});
  const stage = stages[stageIndex];
  const {
    control,
    clearErrors,
    formState: { errors },
    getValues,
    register,
    reset,
    setError,
    setValue,
    trigger,
    watch,
  } = useForm({ defaultValues: defaultValues() });
  const values = watch();

  React.useEffect(() => {
    const controller = new AbortController();

    async function loadPayload() {
      setLoading(true);
      setSubmitError("");

      try {
        const response = await fetch(url, {
          method: "GET",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });

        if (!response.ok) throw new Error(responseErrorMessage(response.status));

        const responseBody = await response.json();
        const payload = responseBody.payload || {};

        setInitHtml(responseBody.init_html || "");
        setServerPayload(payload);
        const nextPayload = deepMerge(defaultValues(), payload);
        reset(nextPayload);
        requestAnimationFrame(() => autosizeTextareas());
      } catch (error) {
        if (!(error instanceof DOMException && error.name === "AbortError")) {
          setSubmitError(
            error instanceof Error ? error.message : "Request failed",
          );
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }

    loadPayload();

    return () => controller.abort();
  }, [url, reset]);

  const submitStage = async (values) => {
    setSubmitting(true);
    setSubmitError("");

    try {
      const token = csrfToken();
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token ? { "X-CSRF-Token": token } : {}),
        },
        body: JSON.stringify({
          payload: trimStringPayload(stageBody(values, stage.names)),
        }),
      });

      if (!response.ok) throw new Error(responseErrorMessage(response.status));

      const payload = await response.json();

      setServerPayload(payload);
      const nextPayload = deepMerge(defaultValues(), payload);
      reset(nextPayload);
      requestAnimationFrame(() => autosizeTextareas());

      if (stageIndex < stages.length - 1) setStageIndex(stageIndex + 1);
    } catch (error) {
      setSubmitError(error instanceof Error ? error.message : "Request failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleStageSubmit = async (event) => {
    event.preventDefault();

    const values = getValues();
    const stageIsValid = await trigger(stage.names);
    const documentsAreValid = validateStageDocuments(
      stage,
      values,
      setError,
      clearErrors,
    );
    const professionalClientGroupsAreValid = validateProfessionalClientGroups(
      stage,
      values,
      setError,
      clearErrors,
    );

    if (
      !stageIsValid ||
      !documentsAreValid ||
      !professionalClientGroupsAreValid
    )
      return;

    await submitStage(values);
  };

  const handleFieldChange = (name) => {
    Promise.resolve().then(async () => {
      await trigger(name);

      const values = getValues();
      const professionalClientGroup = professionalClientGroupForField(
        stage,
        name,
      );

      if (professionalClientGroup) {
        validateProfessionalClientGroup(
          professionalClientGroup,
          values,
          setError,
          clearErrors,
        );
      }
    });
  };

  return h(
    "div",
    { style: styles.shell },
    loading && h("p", { style: styles.paragraph }, "Loading..."),
    h(
      "nav",
      { "aria-label": "KYC stages", style: styles.steps },
      stages.map((item, index) => {
        const complete = stageIsComplete(item, values, serverPayload);

        return h(
          "span",
          { key: item.title },
          // index > 0 && h("small", { style: styles.stepDelimiter }, "—"),
          h(
            "span",
            { style: styles.stepItem },
            h(complete ? CheckCircleIcon : IssueDraftIcon, {
              size: 16,
              style: styles.stepIcon,
            }),
            h(
              "small",
              {
                onClick: (event) => {
                  event.preventDefault();
                  setStageIndex(index);
                },
                style: {
                  ...styles.stepLink,
                  ...(index === stageIndex ? styles.activeStepLink : {}),
                },
              },
              item.title,
            ),
          ),
        );
      }),
    ),
    h(
      "form",
      { onSubmit: handleStageSubmit, style: styles.form },
      h("h3", { style: styles.title }, stage.title),
      stageIndex === 0 &&
        initHtml &&
        h("div", {
          dangerouslySetInnerHTML: { __html: initHtml },
          style: styles.initHtml,
          className: "intro"
        }),
      stage.paragraph && h("p", { style: styles.paragraph }, stage.paragraph),
      stage.fields.map((field) =>
        field.type === "array"
          ? h(ArrayField, {
              key: field.name,
              documentUrl,
              field,
              control,
              clearErrors,
              errors,
              onChange: handleFieldChange,
              register,
              setError,
              setValue,
              values,
            })
          : field.type === "documents"
            ? h(DocumentsField, {
                key: field.name,
                clearErrors,
                documentUrl,
                errors,
                field,
                register,
                setError,
                setValue,
                values,
              })
            : h(Field, {
                key: field.name,
                field,
                register,
                errors,
                onChange: handleFieldChange,
              }),
      ),
      submitError &&
        h(
          "div",
          { role: "alert", style: styles.errorPanel },
          h(AlertFillIcon, { size: 16, style: styles.errorIcon }),
          h("span", null, submitError),
        ),
      h(
        "div",
        { style: styles.actions },
        h(
          "button",
          { type: "submit", disabled: submitting, style: styles.primaryButton },
          submitting
            ? "Submitting..."
            : stageIndex === stages.length - 1
              ? "Submit"
              : "Submit and continue",
        ),
      ),
    ),
  );
}

const styles = {
  shell: {
    display: "grid",
    gap: "20px",
    maxWidth: "920px",
  },
  steps: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  stepDelimiter: {},
  completionMark: {},
  stepItem: {
    alignItems: "center",
    display: "inline-flex",
    gap: "3px",
    whiteSpace: "nowrap",
  },
  stepIcon: {
    display: "block",
    flex: "0 0 auto",
  },
  stepLink: {
    cursor: "pointer",
    textDecoration: "underline",
  },
  activeStepLink: {
    textDecoration: "none",
  },
  form: {
    display: "grid",
    gap: "18px",
  },
  title: {
    margin: 0,
  },
  initHtml: {},
  paragraph: {
    margin: 0,
    maxWidth: "760px",
    lineHeight: 1.45,
  },
  field: {
    display: "grid",
    gap: "5px",
    marginBottom: "10px",
  },
  label: {},
  help: {
    lineHeight: 1.4,
  },
  input: {},
  textarea: {
    boxSizing: "border-box",
    lineHeight: 1.35,
    minHeight: "calc(1.35em + 4px)",
    overflow: "hidden",
    resize: "none",
  },
  choiceInput: {
    flex: "0 0 16px",
    height: "16px",
    margin: "2px 0 0",
    width: "16px",
  },
  checkboxOption: {
    alignItems: "flex-start",
    display: "flex",
    gap: "8px",
    lineHeight: 1.4,
  },
  radioGroup: {
    display: "grid",
    gap: "8px",
  },
  radioOption: {
    alignItems: "flex-start",
    display: "flex",
    gap: "8px",
    lineHeight: 1.4,
  },
  arrayField: {
    display: "grid",
    gap: "12px",
  },
  arrayAddButton: {
    justifySelf: "start",
  },
  arrayItem: {
    border: "1px solid var(--grid-bg-color)",
    borderRadius: "8px",
    display: "grid",
    gap: "14px",
    position: "relative",
    padding: "14px",
  },
  arrayRemoveButton: {
    position: "absolute",
    right: "14px",
    top: "14px",
  },
  documentsList: {
    display: "grid",
    gap: "8px",
    listStyle: "none",
    margin: "8px 0",
    padding: 0,
  },
  documentRemove: {
    cursor: "pointer",
    textDecoration: "underline",
    paddingLeft: "5px",
  },
  actions: {},
  primaryButton: {},
  secondaryButton: {
    background: "#fff",
    border: "1px solid #c9ced8",
    borderRadius: "6px",
    color: "#28313f",
    cursor: "pointer",
    font: "inherit",
    padding: "9px 12px",
  },
  error: {
    alignItems: "center",
    display: "flex",
    gap: "5px",
  },
  errorIcon: {
    display: "block",
    flex: "0 0 auto",
  },
  errorPanel: {
    alignItems: "center",
    // background: "#fff1f0",
    // border: "1px solid #f0b8b0",
    // borderRadius: "6px",
    // color: "#9f1f14",
    display: "flex",
    gap: "5px",
    margin: 0,
    // padding: "10px 12px",
  },
};

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const kyc = document.getElementById("kyc");
    const url = kyc?.getAttribute("data-url");
    const documentUrl = kyc?.getAttribute("data-document-url");

    if (!kyc || !url) return;

    createRoot(kyc).render(h(KycForm, { documentUrl, url }));
  },
  false,
);
